<template>
    <b-container class="d-flex flex-column mw-100 mh-100 h-100 m-0 p-0 overflow-auto flex-wrap">
        <b-row class="m-0 p-0 pr-2 pl-1 h-100 mh-100 w-100 mw-100">
            <b-col class="m-0 p-0 d-flex flex-column">
                <!-- Date de sélection -->
                <b-row class="bg-gray-light m-0 p-0" align-v="center" hidden>
                    <b-col class="border m-0 p-1 pl-2 font-weight-bold">
                        {{ getSelectedDate(factorCalendarTypeEnum.Day, startPeriod, endPeriod) }}
                    </b-col>
                </b-row>
                <!-- Numéro des heures -->
                <b-row class="m-0 p-0 flex-grow-1">
                    <b-col class="m-0 p-0" style="width: 5%; min-width: 5%"/>
                    <b-col class="m-0 p-0" style="width: 95%; min-width: 95%; left:-8px;">
                        <b-row class="m-0 p- w-100 wm-100 h-100 mh-100 border-transparent" align-v="end">
                            <b-col class="m-0 p-0 border-0" v-for="(n,index) in 12" :key="index">
                                <b-row class="m-0 p-0 h-100 mh-100" align-v="end">
                                    <b-col class="m-0 p-0 font-weight-bold">
                                        {{ (n-1)*5 > 9 ? (n-1)*5: '&nbsp;' + (n-1)*5 }}
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <!-- Affichage des jours avec les traits des heures-->
                <b-row class="m-0 p-0 flex-grow-1 border bi-border-white pointor"
                       @click="onClick(undefined, dayInfo.hourId, undefined)"
                       v-for="(dayInfo,index) in dayInfos" :key="index" :style="'height:1em'">
                    <b-col class="m-0 p-0" style="width: 5%; min-width: 5%">
                        <b-row class="m-0 p-0 h-100 mh-100 font-weight-bold" align-v="center" style="font-size:10px;">
                            <b-col class="m-0 p-0 text-right">
                                {{ dayInfo.hourId }}
                            </b-col>
                            <b-col class="m-0 p-0">
                               :00
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="m-0 p-0 d-flex" style="width: 95%; min-width: 95%">
                        <!-- Affichage des traits des heures/minutes -->
                        <svg viewBox="0 0 60 100"
                             width="100%" height="1rem" preserveAspectRatio="none"
                             xmlns="http://www.w3.org/2000/svg" class="flex-grow-1"
                             @click="onClick($event, dayInfo.hourId, undefined)">
                            <defs>
                                <pattern id="pattern-stripe"
                                         width="4" height="4"
                                         patternUnits="userSpaceOnUse"
                                         patternTransform="rotate(45)">
                                    <rect width="2" height="4" transform="translate(0,0)" fill="white"></rect>
                                </pattern>
                                <mask id="mask-stripe">
                                    <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-stripe)"/>
                                </mask>
                            </defs>

                            <template v-for="(data, index) in Data[dayInfo.hourId]?.values">
                                <template v-if="data != undefined">
                                    <template v-if="!Number.isNaN(data.value) && Number(data.value) >= 0">
                                        <template v-if="data.lenghtMinutesValue != 0">
                                            <rect :width="data.lenghtMinutesValue" :height="data.valuePourcent"
                                                  :x="data.startMinutesValue" :y="100 - data.valuePourcent"
                                                  :style="'fill: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                  @mouseover="onMouveOverValues(dayInfo.hourId, data.startMinutesValue)"
                                                  @click="onClick($event, dayInfo.hourId, data.startData.id)"
                                                  :id="'day' + dayInfo.hourId + '_data' + data.startData.id"/>
                                            <polygon points="0.25,50 0.75,15 0.75,85" fill="white" v-if="!data.isFadeIn"
                                                     :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                     stroke-width="0.05"/>
                                            <polygon points="59.75,50 59.25,15 59.25,85" fill="white"
                                                     v-if="!data.isFadeOut"
                                                     :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                     stroke-width="0.05"/>
                                        </template>

                                        <line :x1="data.startMinutesValue" y1="100" class="pointor"
                                              :x2="data.startMinutesValue" :y2="100 - data.valuePourcent"
                                              :style="'stroke: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                              :stroke-width="data.lenghtMinutesValue == 0 ? 0.05 : data.lenghtMinutesValue"
                                              @mouseover="onMouveOverValues(dayInfo.hourId, data.startMinutesValue)"
                                              v-if="data.lenghtMinutesValue == 0"/>
                                    </template>
                                    <template v-else>
                                        <template v-if="data.lenghtMinutesValue != 0">
                                            <rect :width="data.lenghtMinutesValue" :height="data.valuePourcent"
                                                  :x="data.startMinutesValue" y="0"
                                                  :style="'fill: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                  @mouseover="onMouveOverValues(dayInfo.hourId, data.startMinutesValue)"
                                                  @click="onClick($event, dayInfo.hourId, data.startData.id)"
                                                  :id="'day' + dayInfo.hourId + '_data' + data.startData.id"/>
                                            <polygon points="0.25,50 1,15 1,85" fill="white" v-if="!data.isFadeIn"
                                                     :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                     stroke-width="0.05"/>
                                            <polygon points="59.75,50 59,15 59,85" fill="white"
                                                     v-if="!data.isFadeOut"
                                                     :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                     stroke-width="0.05"/>
                                        </template>

                                        <line :x1="data.startMinutesValue" y1="0" class="pointor"
                                              :x2="data.startMinutesValue" :y2="data.valuePourcent"
                                              :style="'stroke: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                              :stroke-width="0.05"
                                              @mouseover="onMouveOverValues(dayInfo.hourId, data.startMinutesValue)"
                                              v-if="data.lenghtMinutesValue == 0"/>
                                    </template>
                                </template>
                            </template>

                            <template v-for="data in OuterData">
                                <line :x1="data.startMinutesValue" y1="0" class="pointor"
                                      :x2="data.startMinutesValue" :y2="100"
                                      :style="'stroke: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                      :stroke-width="1"
                                      @mouseover="onMouveOverValues(dayInfo.hourId, data.startMinutesValue)"
                                      v-if="data.noDay == dayInfo.hourId && data.noMonth == dayInfo.monthId"/>
                            </template>

                            <rect :width="60" height="100" x="0" y="0"
                                  stroke="black" fill="transparent" stroke-width="0.05" style="pointer-events: none"/>

                            <!--#region Les lignes  -->
                            <line x1="1" y1="100" x2="1" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="2" y1="100" x2="2" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="3" y1="100" x2="3" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="4" y1="100" x2="4" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="5" y1="100" x2="5" y2="75" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="6" y1="100" x2="6" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="7" y1="100" x2="7" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="8" y1="100" x2="8" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="9" y1="100" x2="9" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="10" y1="100" x2="10" y2="50" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="11" y1="100" x2="11" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="12" y1="100" x2="12" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="13" y1="100" x2="13" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="14" y1="100" x2="14" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="15" y1="100" x2="15" y2="75" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="16" y1="100" x2="16" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="17" y1="100" x2="17" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="18" y1="100" x2="18" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="19" y1="100" x2="19" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="20" y1="100" x2="20" y2="50" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="21" y1="100" x2="21" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="22" y1="100" x2="22" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="23" y1="100" x2="23" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="24" y1="100" x2="24" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="25" y1="100" x2="25" y2="75" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="26" y1="100" x2="26" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="27" y1="100" x2="27" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="28" y1="100" x2="28" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="29" y1="100" x2="29" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="30" y1="100" x2="30" y2="50" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="31" y1="100" x2="31" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="32" y1="100" x2="32" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="33" y1="100" x2="33" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="34" y1="100" x2="34" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="35" y1="100" x2="35" y2="75" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="36" y1="100" x2="36" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="37" y1="100" x2="37" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="38" y1="100" x2="38" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="39" y1="100" x2="39" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="40" y1="100" x2="40" y2="50" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="41" y1="100" x2="41" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="42" y1="100" x2="42" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="43" y1="100" x2="43" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="44" y1="100" x2="44" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="45" y1="100" x2="45" y2="75" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="46" y1="100" x2="46" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="47" y1="100" x2="47" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="48" y1="100" x2="48" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="49" y1="100" x2="49" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="50" y1="100" x2="50" y2="50" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="51" y1="100" x2="51" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="52" y1="100" x2="52" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="53" y1="100" x2="53" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="54" y1="100" x2="54" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="55" y1="100" x2="55" y2="75" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="56" y1="100" x2="56" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="57" y1="100" x2="57" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="58" y1="100" x2="58" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>
                            <line x1="59" y1="100" x2="59" y2="90" stroke="black" stroke-width="0.05" style="pointer-events: none"/>

                            <!--#endregion -->
                        </svg>

                        <template v-for="(data, index) in Data[dayInfo.hourId]?.values">
                            <template v-if="data != undefined">
                                <!-- Première partie - la valeur -->
                                <svg :width="(100 / 60 * data.lenghtMinutesValue) + '%'" height="1rem"
                                     :style="'left: ' + (100 / 60 * data.startMinutesValue) + '%'"
                                     class="position-absolute" style="pointer-events: none;"
                                     v-if="data.lenghtMinutesValue > 2">
                                    <text x="50%" y="50%" text-anchor="middle" font-size="0.75rem"
                                          dominant-baseline="middle" fill="white" class="shadow"
                                          style="pointer-events: auto;"
                                          @click="onClick($event, dayInfo.hourId, data.startData.id)">
                                        {{ Intl.NumberFormat('fr-FR').format(data.value) }}
                                    </text>
                                </svg>

                                <!-- Deuxième partie - la popup -->
                                <b-popover triggers="hover" placement="top"
                                           v-if="SelectedFactor?.Temporality == 1"
                                           :target="'day' + dayInfo.hourId + '_data' + data.startData.id">
                                    <div class="m-0 p-1 d-flex flex-row flex-wrap" text-variant="dark">
                                        <div class="d-flex m-1 p-0">
                                            <div class="flex-column border p-1 m-0 text-center"
                                                 :class="'border-' + ColorNotCaclulateData[data.periodicity]">
                                                {{ getMomentDateToString(data.startData.date, true) }}
                                            </div>
                                            <div class="left-arrow"
                                                 :class="'bg-' + ColorNotCaclulateData[data.periodicity]"></div>
                                            <div
                                                class="pl-2 pr-2 m-0 flex-grow-1 mh-100 h-100 font-weight-bold text-white"
                                                :class="'bg-' + ColorNotCaclulateData[data.periodicity] +
                                              ' border-' + ColorNotCaclulateData[data.periodicity]">
                                                    <span class="d-flex align-items-center h-100 mh-100">
                                                        {{ Intl.NumberFormat('fr-FR').format(data.value) }}
                                                    </span>
                                            </div>
                                            <div class="right-arrow"
                                                 :class="'bg-' + ColorNotCaclulateData[data.periodicity] +
                                              ' border-' + ColorNotCaclulateData[data.periodicity]"></div>
                                            <div class="p-1 m-0 border text-center"
                                                 :class="'border-' + ColorNotCaclulateData[data.periodicity]">
                                                {{ getMomentDateToString(data.endData.date, false) }}
                                            </div>
                                        </div>
                                    </div>
                                </b-popover>
                            </template>
                        </template>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">

import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import moment from "moment";
import {mixins} from "vue-class-component";
import {FactorUtils} from "./FactorUtils";
import FactorCalendarTypeEnum from "@/enums/FactorCalendarTypeEnum";

@Component({
    computed: {
        FactorCalendarTypeEnum() {
            return FactorCalendarTypeEnum
        }
    },
    methods: {},
    components: {}
})

export default class FactorCalendarDay extends mixins(Vue, FactorUtils) {

    @Prop()
    public Variant: string;

    /** Données du facteur sur cette période */
    @Prop({default: () => []})
    public Data!: any[];

    /** Premières Données du facteur en dehors de la période */
    @Prop()
    public OuterData!: any[];

    /** Pour l'affichage des données en tooltip */
    @PropSync("HoverDatas", {default: () => []})
    public hoverDatas!: any[];

    /** Paramètres transmis pour l'ajout, la modification/suppression des données*/
    @PropSync("ShowDatas", {default: () => []})
    public showDatas!: any[];
    @PropSync("ShowModal", {default: () => false})
    public showModal!: boolean;

    /** Date sélectionnée*/
    @Prop({default: () => Date.now()})
    public SelectedDate: Date;

    /** Couleur des données suivant le type de facteur */
    @Prop({default: () => 'tertiary'})
    public ColorCaclulateData: string;
    @Prop({default: () => ['primary']})
    public ColorNotCaclulateData: string[];

    /** Facteur sélectionné */
    @Prop({default: () => {}})
    public SelectedFactor!: any;

    /** Période affichée */
    @PropSync("StartPeriod")
    public startPeriod: moment.Moment;
    @PropSync("EndPeriod")
    public endPeriod: moment.Moment;

    /** Pour accéder à l'enum dans la partie template */
    private factorCalendarTypeEnum = FactorCalendarTypeEnum;

    /** Propriété pour la modale */
    private selectedDate: Date = new Date(Date.now());

    /** Information du calendrier à afficher */
    private dayInfos: { hourId: number, dayId: number, hourName: string }[] = [];
    /** Informations des données par minutes et jours */
    private tooltipData: any[] = [];

    /**
     * Pour l'affectation de la variable privée selectedDate
     * @protected
     */
    @Watch('SelectedDate', {immediate: true})
    protected modifedDate() {
        console.debug('FactorCalendarMonth.vue - modifedDate');
        this.selectedDate = this.SelectedDate;
    }

    /**
     * Recalcule du calendrier à afficher
     * @protected
     */
    @Watch("SelectedDate")
    protected updateSelectedDate() {
        console.debug('FactorCalendarMonth.vue - SelectedDate');
        this.loadCalendar();
    }

    /**
     * Rechargement des listes liées aux données
     * @protected
     */
    @Watch("Data", {deep: true, immediate: true})
    protected setData() {
        console.debug('FactorCalendarMonth.vue - setData');
        this.tooltipData = [];
        this.loadDatas().then(() => {
        });
    }

    /**
     * Pour l'affichage des valeurs survolées sur la minute
     * @param hour
     * @param minute
     * @private
     */
    private onMouveOverValues(hour: number, minute: number) {
        this.hoverDatas = [...this.tooltipData[hour][minute]];
        console.debug('FactorCalendarMonth.vue - onMouveOverValues - hour, minute', hour, minute, this.hoverDatas);
    }

    /** Pour éviter les clicks intempestifs */
    private onClickDate: moment.Moment = moment();
    /**
     * Récupération des données au click pour l'ajout ou la modification/suppression des données à cette minute
     * @param evt
     * @param hour
     * @param dataId
     * @private
     */
    private onClick(evt, hour, dataId = undefined) {
        if (this.SelectedFactor != undefined && this.SelectedFactor != null) {
            console.debug('FactorCalendarMonth.vue - onClick - evt : %O - hour : %O - dataId : %O', evt, hour, dataId);
            let datas: any[] = [];
            let minuteClick = 0;

            console.debug('FactorCalendarMonth.vue - onClick - diff time between click : %O', moment().diff(this.onClickDate));

            if (moment().diff(this.onClickDate) > 100) {
                this.onClickDate = moment();
                if (dataId == undefined) {
                    if (evt != undefined) {
                        let dim = evt.target.getBoundingClientRect();
                        let x = evt.clientX - dim.left;
                        let y = evt.clientY - dim.top;
                        console.debug('FactorCalendarMonth.vue - onClick - dim, x, y', dim, x, y);

                        minuteClick = Math.round(x * 60 / dim.width);

                        if (minuteClick != Infinity && minuteClick != -Infinity) {
                            for (let j = 0; j < this.tooltipData[hour][minuteClick]?.length; j++) {
                                let a = {...this.tooltipData[hour][minuteClick][j]};
                                console.debug('FactorCalendarMonth.vue - onClick - hour, minuteClick, a', hour, minuteClick, a);
                                if (a == undefined || (Object.keys(a).length == 0 && a.constructor == Object)) {
                                } else {
                                    console.debug('FactorCalendarMonth.vue - onClick - startDate', a.startData.date);
                                    let startDate = this.getMomentDate(a.startData.date, true);
                                    console.debug('FactorCalendarMonth.vue - onClick - endDate', a.endData.date);
                                    let endDate = this.getMomentDate(a.endData.date, true);
                                    datas.push({
                                        NoMonth: a.startData.noMonth,
                                        NoDay: a.startData.noDay,
                                        Status: 1,
                                        DataId: a.startData.id,
                                        StartDate: startDate.format('YYYY-MM-DD'),
                                        StartTime: startDate.format('HH:mm'),
                                        EndDate: endDate.format('YYYY-MM-DD'),
                                        EndTime: endDate.format('HH:mm'),
                                        Periodicity: a.periodicity,
                                        Value: a.value,
                                        Unit: a.unit,
                                        Collapsed: false
                                    });
                                }
                            }
                        }
                        console.debug('FactorCalendarMonth.vue - onClick - minuteClick', minuteClick);
                    }
                } else {
                    /** Affichage de la donnée sélectionnée */
                    let a = this.Data[hour].values.find((a) => a.startData.id == dataId);
                    if (this.OuterData != undefined && this.OuterData.length > 0 && a == undefined || a.length == 0) {
                        let value = this.OuterData.find(a => a.id == dataId);
                        if (value != undefined)
                            a = {
                                endData: {...this.OuterData[0]},
                                isFadeIn: false,
                                isFadeOut: false,
                                lenghtMinutesValue: 0,
                                periodicity: this.OuterData[0].periodicity,
                                startData: {...this.OuterData[0]},
                                startMinutesValue: this.OuterData[0].startMinutesValue,
                                unit: this.OuterData[0].unit,
                                value: this.OuterData[0].value,
                                valuePourcent: 100
                            };
                    }
                    console.debug('FactorCalendarMonth.vue - onClick - dataId : %O, a: %O, hour: %O, this.Data : %O',
                        dataId, a, hour, this.Data);
                    if (a != undefined) {
                        console.debug('FactorCalendarMonth.vue - onClick - startDate: ', a.startData.date);
                        let startDate = this.getMomentDate(a.startData.date, true);
                        console.debug('FactorCalendarMonth.vue - onClick - endDate :', a.endData.date);
                        let endDate = this.getMomentDate(a.endData.date, true);
                        console.debug('FactorCalendarMonth.vue - onClick - startDate : %O, endDate : %O', startDate, endDate);
                        if (this.SelectedFactor?.Temporality == 3 && a.startData.date != a.endData.date) {
                            datas.push({
                                NoMonth: a.startData.noMonth,
                                NoDay: a.startData.noDay,
                                Status: 1,
                                DataId: a.startData.id,
                                StartDate: startDate?.format('YYYY-MM-DD'),
                                StartTime: startDate?.format('HH:mm'),
                                EndDate: startDate?.format('YYYY-MM-DD'),
                                EndTime: startDate?.format('HH:mm'),
                                Periodicity: a.periodicity,
                                Value: a.startData.value, Unit: a.unit, Collapsed: false
                            });
                            datas.push({
                                NoMonth: a.endData.noMonth,
                                NoDay: a.endData.noDay,
                                Status: 1,
                                DataId: a.endData.id,
                                StartDate: endDate?.format('YYYY-MM-DD'),
                                StartTime: endDate?.format('HH:mm'),
                                EndDate: endDate?.format('YYYY-MM-DD'),
                                EndTime: endDate?.format('HH:mm'),
                                Periodicity: a.periodicity,
                                Value: a.endData.value,
                                Unit: a.unit,
                                Collapsed: false
                            });
                        } else {
                            datas.push({
                                NoMonth: a.startData.noMonth,
                                NoDay: a.startData.noDay,
                                Status: 1,
                                DataId: a.startData.id,
                                StartDate: startDate?.format('YYYY-MM-DD'),
                                StartTime: startDate?.format('HH:mm'),
                                EndDate: endDate?.format('YYYY-MM-DD'),
                                EndTime: endDate?.format('HH:mm'),
                                Periodicity: a.periodicity,
                                Value: a.value, Unit: a.unit, Collapsed: false
                            });
                        }
                        console.debug('FactorCalendarMonth.vue - onClick - datas :', datas);
                    }
                }

                if (datas.length > 0) {
                    datas[0].Collapsed = true;
                } else {
                    /** Ajout d'une nouvelle donnée */
                    console.debug('FactorCalendarMonth.vue - onClick - selectedDate :', this.selectedDate);
                    let date = this.getMomentDate(this.selectedDate, true);
                    console.debug('FactorCalendarMonth.vue - onClick - date', date, minuteClick);
                    date = moment({year: date.year(), month: date.month(), day: date.date(), hour: hour});
                    if (minuteClick != undefined) {
                        date.add(minuteClick, 'minutes');
                    }
                    console.debug('FactorCalendarMonth.vue - onClick - date :', date);
                    let dataId = Math.abs(Math.min(...this.Data.map(a=> a.ids).flat())) ;
                    if (dataId ==  Infinity || isNaN(dataId)) {
                        dataId = 0;
                    }
                    datas.push({
                        NoMonth: date.month() + 1,
                        NoDay: date.date(),
                        Status: 0, DataId: dataId * (-1) - 1,
                        StartDate: date.format('YYYY-MM-DD'), StartTime: date?.format('HH:mm'),
                        EndDate: date.format('YYYY-MM-DD'), EndTime: date?.format('HH:mm'),
                        Periodicity: 0, Value: undefined, Unit: this.SelectedFactor?.Unit, Collapsed: true
                    });
                }

                Vue.set(this, 'onClickDate', moment());
                Vue.set(this, 'showDatas', [...datas]);
                Vue.set(this, 'showModal', datas.length > 0 && this.SelectedFactor.Temporality == 1 /* Limited */);
                console.debug('FactorCalendarMonth.vue - onClick - this.showDatas : %O - hour : %O', this.showDatas, hour);
            }
            this.onClickDate = moment();

            if (this.SelectedFactor.Temporality != 1 /* Limited */){
                this.$bvToast.toast(this.$t('FactorEditDisabled').toString(),{ // .$t('FactorEditDisabled') / "Il n'est pas encore possible de modifier des facteurs de type indexés ou instantanés.", {
                    title: this.$t('ImpossibleAction').toString(), // $t('ImpossibleAction') / "Action impossible",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
        }
    }

    /**
     * Chargement de données pour les trier par minutes
     * @protected
     */
    protected loadDatas(): Promise<any> {
        console.debug('FactorCalendarMonth.vue - loadDatas');
        this.hoverDatas = [];
        return new Promise(async (resolve, reject) => {
            this.tooltipData = [];
            if (this.Data != undefined && this.Data.length > 0) {
                for (let i = 0; i < this.Data.length; i++) {
                    let datas = {...this.Data[i]};
                    this.tooltipData.push([]);
                    for (let j = 0; j < 60; j++) {
                        let dataMinute: any[] = [];
                        // Seule des données de type instantané auront un tooltip.
                        dataMinute = datas.values.filter(a => a.startMinutesValue == j);
                        dataMinute.forEach(a => {
                            a.noStep = i;
                            return a
                        });
                        this.tooltipData[i].push(dataMinute);
                    }
                    if (this.OuterData!= undefined && this.OuterData.length > 0 && i == this.OuterData[0].noDay - 1){
                        this.tooltipData[i][this.OuterData[0].startMinutesValue].push({
                            endData: {...this.OuterData[0]},
                            isFadeIn:false,
                            isFadeOut:false,
                            noStep: i,
                            lenghtMinutesValue:0,
                            periodicity:this.OuterData[0].periodicity,
                            startData: {...this.OuterData[0]},
                            startMinutesValue:this.OuterData[0].startMinutesValue,
                            unit:this.OuterData[0].unit,
                            value:this.OuterData[0].value,
                            valuePourcent:100
                        });
                    }
                }
            }
            resolve(true);
        });
    }

    /**
     * Chargement du calendrier
     * @private
     */
    private loadCalendar() {
        console.debug('FactorCalendarMonth.vue - loadCalendar');
        let startDate: moment.Moment = moment(moment(this.selectedDate).clone().toDate()); /* pour supprimer les heures */
        let endDate: moment.Moment = startDate.clone();

        moment.locale('fr');

        this.dayInfos = [];
        startDate = moment(startDate.year() + '-' + (startDate.month() + 1 /* les mois commencent à 0. */) + '-' + startDate.date());

        /* Calcul des dates de changement d'heure */
        /*let gmt2 = startDate.clone().add({hours: 4}).toDate().toTimeString();
        let gmt0 = startDate.clone().subtract({days: 1}).add({hours: 4}).toDate().toTimeString();
        let dayClocksChange = gmt2.substring(gmt2.indexOf('('), gmt2.length) != gmt0.substring(gmt0.indexOf('('), gmt0.length)
            ? gmt2.substring(gmt2.indexOf('('), gmt2.length) == "(heure d’été d’Europe centrale)" ? -1 : +1 : 0;*/

        endDate = startDate.clone().add({day: 1});
        let nbHours = endDate.diff(startDate, 'hours');
        console.debug('FactorCalendarMonth.vue - loadCalendar - nbHours', nbHours);
        for (let i = 0; i < nbHours; i++) {
             let date = startDate.clone().add({hour: i});
             /*if(i == 2) {
                 if (dayClocksChange == -1) {
                     // une heure de moins (Changement d'heure)
                     // pas d'ajout de l'heure 2.
                 } else {
                     this.dayInfos.push({
                         hourId: date.hours(),
                         dayId: date.date(),
                         hourName: date.hours() + "h"
                     });
                 }
                 if (dayClocksChange == 1) {
                     // une heure de plus (Changement d'heure)
                     this.dayInfos.push({
                         hourId: date.hours(),
                         dayId: date.date(),
                         hourName: date.hours() + "h"
                     });
                 }
             }
             else {*/
                 this.dayInfos.push({
                     hourId: date.hours(),
                     dayId: date.date(),
                     hourName: date.hours() + "h"
                 });
             //}
        }

        console.debug('FactorCalendarMonth.vue - loadCalendar - startDate, endDate, dayInfos', startDate.toDate(),
            endDate.toDate(), this.dayInfos);

        this.startPeriod = startDate;
        this.endPeriod = endDate;
    }

    /** Au chargement */
    mounted() {
        console.debug('FactorCalendarMonth.vue - mounted');
        this.loadCalendar();

        this.tooltipData = [];
        this.loadDatas().then(() => {
        });
    }
}

</script>
<style scoped>

/** Style pour afficher dans le tooltip la flèche de droite */
:deep(.right-arrow) {
    position: relative;
    left: -1px;
    width: 15px !important;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
}

/** Style pour afficher dans le tooltip la flèche de gauche */
:deep(.left-arrow) {
    position: relative;
    right: -1px;
    width: 15px !important;
    clip-path: polygon(100% 100%, 100% 0, 0 50%);
}

:deep(.shadow) {
    /* Plusieurs pour accentuer le contour. */
    text-shadow: 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black,
    0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black;
}

:deep(.pointor){
    cursor: pointer;
}

</style>